export const MAX_MESSAGE_LENGTH = 150;
export const MAX_MESSAGE_HISTORY = 100;

export const LINK_PATTERNS = [
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/gi,
  /www\.[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/gi,
  /(?:^|[^@\w])([a-zA-Z0-9][-a-zA-Z0-9]{0,61}[a-zA-Z0-9]?\.)+[a-zA-Z]{2,}(?:[/\w\-._~:/?#[\]@!$&'()*+,;=%]*)?/gi,
  /(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?::[0-9]{1,5})?(?:[/\w\-._~:/?#[\]@!$&'()*+,;=%]*)?/gi,
];
